const { Core, Utils, Events } = Global;
const { $fetch, parseHTML } = Utils;


customElements.define('cart-provider', class extends Core {
    liveSections = new Set();

    render() {
        this.sub(Events.CART_REGISTER, this._registerSection, { global: true });
        this.sub(Events.CART_ADD, this._addToCart, { global: true });
        this.sub(Events.CART_CHANGE, this._updateCart, { global: true });
    }

    _registerSection(section) {
        this.liveSections.add(section);
    }
    
    async _addToCart({ items }) {
    var item = $(`.min_qty.p_var_min-${items[0].id}`);
    var qty = items[0].quantity * 1;
    var min_qty = item.data('minqty') * 1;
    var type = item.data('type');
    if (type === 'minimum_order') {
console.log("minimum_order")
        if (min_qty > qty) {
            qty = min_qty;
        }
    } else if(type === 'sale_unit'){

        // Check if qty is a multiple of min_qty
        if (qty % min_qty !== 0) {
            // Calculate the nearest higher multiple of min_qty
            qty = Math.ceil(qty / min_qty) * min_qty;
        }
      
    }
    // Update the quantity in the items array
    items[0].quantity = qty;
    // Now 'items' array will have the updated quantity for the first item
    console.log(items,"items--------->>");

        await this._requestCart('cartAdd', {
            items,
            attributes: {
                notification_items_variant_ids: items.map(({id}) => id).join(',')
            }
        }, items.map(item => item.id));
        this._cleanCartAttributes();
    }

    _cleanCartAttributes() {
        this._fetchCart('cartUpdate', { attributes: { notification_items_variant_ids: null }});
    }

    _fetchCart(route, body) {
        return fetch(`${window.dynamicURLs[route]}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(
                body
            )
        })
    }

    async _updateCart({ key, quantity, selling_plan }) {        
        // TODO: depracate implicit variantId
        const [variantId] = key.split(':');
        await this._requestCart('cartChange', {
            id: key, quantity, selling_plan,
        }, [variantId]);
    }

    async _requestCart(route, body, items, keys) {
        try {
            const res = await this._fetchCart(route, {
                ...body,
                sections: Array.from(this.liveSections).join(','),
            });
            
            const cartData = await res.json();

            if(!res.ok) {
                this.pub(Events.TOAST_NOTIFICATION, {
                    type: 'error',
                    msg: cartData.description,
                    title: cartData.message
                });
                throw new Error(cartData.description);
            }
      
            this.pub(Events.CART_UPDATE, {
                sections: cartData.sections,
                req: route,
                items,
                keys
            })

            var variantMetafieldsLength = $('.variant_metafields').length;
            console.log(variantMetafieldsLength);
            if(variantMetafieldsLength > 0){
   console.log("disabb");
            var type = $('.variant_metafields').data('type');
            var title = $('.variant_metafields').data('title');
            var qty = $('.variant_metafields').data('minqty');
            $('.popupMinItemQty').text(qty);
            $('.popupPoductTitle').text(title);
            $('.pop-text').hide();
            $(type).show();
            $(".sweet-alert").show();
            $('#cart-drawer-live-region-checkout').addClass('disabled');
            }else{
      console.log("disable");
              $(".sweet-alert").hide();
            $('#cart-drawer-live-region-checkout').removeClass('disabled');
            }

            var text = $('.item-0_qty').text();
            if(text !== ''){
            $('.cart-min-msg').show();
            $('.cart-min-msg .alert--content').text(text);
            }else{
            $('.cart-min-msg').hide();
            }

        } catch (error) {
            console.error(error);
            this.pub(Events.CART_ERROR, error);
        }
    }
})

customElements.define('cart-qty', class extends Core {
    propTypes = {
        value: Number,
        key: String,
        input: Boolean,
        'prevent-default': Boolean
    }

    render() {
        this.$({
            [this.evt]: this._handleEvent
        })
    }

    _handleEvent(e) {
        this.prop('prevent-default') && e.preventDefault();
        this.pub(Events.CART_CHANGE, {
            key: this.prop('key'),
            quantity: this._getValue(e)
        })
    }

    _getValue(e) {
        return this.evt === 'change' 
            ? e.target.value 
            : this.prop('value'); 
    }

    get evt() {
        return this.prop('input') 
            ? 'change' 
            : 'click';
    }
});

customElements.define('cart-live-region', class extends Core {
    propTypes = {
        'target-section': String,
        'target-element': String
    }

    render() {
        this.targetSection = this.prop('target-section') || this.sectionId;
        this.targetSelector = this.prop('target-element') || `#${this.id}`;

        customElements.whenDefined('cart-provider').then(() => {
            this.pub(Events.CART_REGISTER, this.targetSection)
        })

        this.sub(Events.CART_UPDATE, this._updateContent, { global: true })
    }
    
    _updateContent({ sections }) {
        const targetSection = sections && sections[this.targetSection];
        if(!targetSection) {
            console.error(`target section ${targetSection} do not exists`);
            return;
        }





        const doc = Utils.parseHTML(targetSection);
        Utils.$replaceContent(this, doc.querySelector(this.targetSelector));


    }
})